import { render } from "./ResponsablesPatient.vue?vue&type=template&id=3939843b&scoped=true"
import script from "./ResponsablesPatient.vue?vue&type=script&lang=js"
export * from "./ResponsablesPatient.vue?vue&type=script&lang=js"

import "./ResponsablesPatient.vue?vue&type=style&index=0&id=3939843b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3939843b"]])

export default __exports__